module.exports = __webpack_public_path__ + "img/dsci0019.8f11ddfb.jpg";